"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCashback = function SvgCashback(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 2h9a5 5 0 0 1 3.506 8.565c-.305.3-.73.432-1.158.435h-6.027l3.043-3.043a1 1 0 0 0-1.414-1.414l-4.701 4.7a1 1 0 0 0-.218 1.088.997.997 0 0 0 .222.336l4.697 4.697a1 1 0 0 0 1.414-1.414L11.414 13h5.919c.433 0 .864.131 1.173.435A5 5 0 0 1 15 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z",
    fill: "url(#cashback_svg__a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cashback_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-16.5 0 0 -13.2 17 12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CAC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#13B8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#386CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693CB8"
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgCashback);
var _default = Memo;
exports["default"] = _default;